/**
 * A functional-status level's words and chip colour, the one source for
 * every surface that shows a level (the Functional status card, the face
 * sheet). LP-19, Amanda: Dependent is red for every activity, Needs
 * assistance gold (the record's awaiting-confirm gold, chosen over beige
 * "because it might get missed"), Independent green, Not assessed neutral.
 * The colour follows the level alone, never the activity.
 */
import type { ChipVariant } from '@/components/primitives/Chip';
import type { FunctionalLevel } from '@/lib/clientRecord';

export const FUNCTIONAL_LEVEL_PILL: Readonly<Record<FunctionalLevel, { label: string; variant: ChipVariant }>> = {
  independent: { label: 'Independent', variant: 'affirm' },
  needs_assistance: { label: 'Needs assistance', variant: 'caution' },
  dependent: { label: 'Dependent', variant: 'risk' },
  not_assessed: { label: 'Not assessed', variant: 'neutral' },
};
